export default __webpack_public_path__ + "static/media/coi-prime.5ed86f1e.svg";